import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import MaintenanceScreen from './MaintenanceScreen';
import { getCookie, setCookie } from '../utils/cookieUtils';

/**
 * メンテナンスモードラッパー
 * 環境変数 REACT_APP_MAINTENANCE_MODE=true の時にメンテナンス画面を表示
 * クエリパラメータ ?bypass=Sakura12301 でcookieを設定してバイパス可能
 */
const MaintenanceWrapper = ({ children }) => {
  const location = useLocation();
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // メンテナンスモードが有効かチェック
    const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

    if (!maintenanceMode) {
      setIsMaintenanceMode(false);
      setIsChecking(false);
      return;
    }

    // クエリパラメータをチェック
    const params = new URLSearchParams(location.search);
    const bypassParam = params.get('bypass');

    // 正しいバイパスキーの場合、cookieを設定
    if (bypassParam === 'Sakura12301') {
      setCookie('maintenance_bypass', 'true', 24);
      setIsMaintenanceMode(false);
      setIsChecking(false);
      return;
    }

    // cookieにバイパスが設定されているかチェック
    const bypassCookie = getCookie('maintenance_bypass');
    if (bypassCookie === 'true') {
      setIsMaintenanceMode(false);
      setIsChecking(false);
      return;
    }

    // メンテナンス画面を表示
    setIsMaintenanceMode(true);
    setIsChecking(false);
  }, [location]);

  // チェック中は何も表示しない
  if (isChecking) {
    return null;
  }

  // メンテナンスモードの場合はメンテナンス画面を表示
  if (isMaintenanceMode) {
    return <MaintenanceScreen />;
  }

  // 通常画面を表示
  return <>{children}</>;
};

export default MaintenanceWrapper;
